import { render } from "./MoreServicesSection.vue?vue&type=template&id=bb48d1a8"
import script from "./MoreServicesSection.vue?vue&type=script&lang=js"
export * from "./MoreServicesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__